(() => {
  function initCatalog(root) {
    const catalog = root.querySelector('[data-nawr-catalog]');
    if (!catalog || catalog.dataset.ready) return;
    catalog.dataset.ready = 'true';
    const grid = catalog.querySelector('[data-grid]');
    const cards = [...grid.querySelectorAll('[data-product-card]')];
    const search = catalog.querySelector('[data-search]');
    const sort = catalog.querySelector('[data-sort]');
    const count = catalog.querySelector('[data-count]');
    const empty = catalog.querySelector('[data-empty]');
    const bar = catalog.querySelector('[data-compare-bar]');
    const dialog = catalog.querySelector('[data-compare-dialog]');
    const selected = new Set();
    let active = 'tutti';
    const filters = [...catalog.querySelectorAll('[data-filter]')];

    const updateBar = () => {
      bar.hidden = selected.size === 0;
      bar.querySelector('[data-compare-count]').textContent = selected.size + (selected.size === 1 ? ' selezionato' : ' selezionati');
      bar.querySelector('[data-open-compare]').disabled = selected.size < 2;
      cards.forEach(card => {
        const input = card.querySelector('[data-compare]');
        input.disabled = selected.size >= 3 && !selected.has(card);
      });
    };
    const render = () => {
      const q = search.value.trim().toLocaleLowerCase('it');
      const ordered = [...cards];
      if (sort.value === 'price-asc') ordered.sort((a, b) => +a.dataset.price - +b.dataset.price);
      if (sort.value === 'price-desc') ordered.sort((a, b) => +b.dataset.price - +a.dataset.price);
      ordered.forEach(card => grid.append(card.parentElement));
      let visible = 0;
      cards.forEach(card => {
        const match = (active === 'tutti' || card.dataset.category === active) &&
          (card.dataset.title + ' ' + card.dataset.message).toLocaleLowerCase('it').includes(q);
        card.parentElement.hidden = !match;
        if (match) visible++;
      });
      count.textContent = String(visible).padStart(2, '0') + (visible === 1 ? ' PRODOTTO' : ' PRODOTTI');
      empty.hidden = visible !== 0;
    };
    filters.forEach(button => button.addEventListener('click', () => {
      active = button.dataset.filter;
      filters.forEach(item => {
        const on = item === button;
        item.classList.toggle('active', on);
        item.setAttribute('aria-pressed', String(on));
      });
      render();
    }));
    search.addEventListener('input', render);
    sort.addEventListener('change', render);
    cards.forEach(card => card.querySelector('[data-compare]').addEventListener('change', event => {
      event.target.checked ? selected.add(card) : selected.delete(card);
      updateBar();
    }));
    catalog.querySelector('[data-clear-compare]').addEventListener('click', () => {
      selected.clear();
      cards.forEach(card => { card.querySelector('[data-compare]').checked = false; });
      updateBar();
    });
    catalog.querySelector('[data-open-compare]').addEventListener('click', () => {
      const table = document.createElement('table');
      table.className = 'compare-table';
      const chosen = cards.filter(card => selected.has(card));
      const thead = document.createElement('thead');
      const header = document.createElement('tr');
      ['PRODOTTO', ...chosen.map(card => card.dataset.title)].forEach(text => {
        const th = document.createElement('th');
        th.scope = 'col';
        th.textContent = text;
        header.append(th);
      });
      thead.append(header);
      const tbody = document.createElement('tbody');
      const fields = [
        ['Messaggio', card => card.dataset.category.toUpperCase()],
        ['Tipo', card => card.dataset.type],
        ['Prezzo', card => card.dataset.priceText]
      ];
      fields.forEach(([label, getter]) => {
        const row = document.createElement('tr');
        const heading = document.createElement('td');
        heading.textContent = label;
        row.append(heading);
        chosen.forEach(card => {
          const cell = document.createElement('td');
          cell.textContent = getter(card);
          row.append(cell);
        });
        tbody.append(row);
      });
      const row = document.createElement('tr');
      const heading = document.createElement('td');
      heading.textContent = 'Scopri';
      row.append(heading);
      chosen.forEach(card => {
        const cell = document.createElement('td');
        const link = document.createElement('a');
        link.href = card.dataset.url;
        link.textContent = 'Vai al prodotto ↗';
        cell.append(link);
        row.append(cell);
      });
      tbody.append(row);
      table.append(thead, tbody);
      catalog.querySelector('[data-compare-table]').replaceChildren(table);
      dialog.showModal();
    });
    catalog.querySelector('[data-close-compare]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    render();
    updateBar();
  }

  function initVariants(root) {
    root.querySelectorAll('[data-variant-select]').forEach(select => {
      if (select.dataset.ready) return;
      select.dataset.ready = 'true';
      const summary = select.closest('.product-summary');
      const price = summary.querySelector('[data-variant-price]');
      const button = summary.querySelector('[data-add-button]');
      const gallery = summary.closest('.product-layout').querySelector('[data-product-gallery]');
      const colorChoices = [...summary.querySelectorAll('[data-color-choice]')];
      const showSelectedVariant = () => {
        const option = select.selectedOptions[0];
        price.textContent = option.dataset.price;
        button.disabled = option.dataset.available !== 'true';
        button.textContent = button.disabled ? 'Esaurito' : 'Aggiungi al carrello';
        colorChoices.forEach(choice => {
          const active = choice.dataset.colorChoice === option.dataset.color;
          choice.classList.toggle('is-active', active);
          choice.setAttribute('aria-pressed', String(active));
        });
        if (gallery && colorChoices.length) showVariantGallery(gallery, option, colorChoices.map(choice => choice.dataset.colorChoice));
      };
      colorChoices.forEach(choice => choice.addEventListener('click', () => {
        const size = select.selectedOptions[0]?.dataset.size;
        const matches = [...select.options].filter(option => option.dataset.color === choice.dataset.colorChoice);
        const target = matches.find(option => option.dataset.size === size && option.dataset.available === 'true') || matches.find(option => option.dataset.available === 'true') || matches[0];
        if (!target) return;
        select.value = target.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }));
      select.addEventListener('change', showSelectedVariant);
      showSelectedVariant();
    });
  }
  function showVariantGallery(gallery, option, colors) {
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    if (!thumbs.length) return;
    const colorAliases = {
      'rosa-chiaro': ['light-pink'],
      lavanda: ['lavender'],
      nero: ['black'],
      bianco: ['white']
    };
    const filenameOf = thumb => thumb.dataset.full.split('?')[0].split('/').pop().toLowerCase().replaceAll('_', '-');
    const namedColor = (thumb, color) => {
      const filename = filenameOf(thumb);
      return [color, ...(colorAliases[color] || [])].some(name => filename.includes(`-${name}-`) || filename.startsWith(`${name}-`));
    };
    const color = option.dataset.color;
    const featured = thumbs.find(thumb => thumb.dataset.mediaId === option.dataset.mediaId && option.dataset.mediaId);
    const named = color ? thumbs.filter(thumb => namedColor(thumb, color)) : [];
    let visible = thumbs;
    let mainEditorial;
    if (named.length) {
      visible = featured && !colors.some(other => namedColor(featured, other)) ? [featured, ...named.filter(thumb => thumb !== featured)] : named;
    } else if (featured) {
      visible = [featured];
    }
    if (gallery.dataset.productHandle === 'felpa-unisex-sabr-la-pazienza-e-forza-nawr' && color === 'rosa-chiaro') {
      const editorial = thumbs.filter(thumb => !filenameOf(thumb).includes('unisex-premium-pullover-hoodie'));
      visible = [...new Set([...editorial, ...visible])];
      mainEditorial = editorial.find(thumb => filenameOf(thumb).includes('studio-sereno-con-hoodie-sabr')) || editorial[0];
    }
    if (gallery.dataset.productHandle === 'felpa-just-relax-it-s-dunya') {
      const details = named.filter(thumb => /-(back|zoomed-in|product-details)-/.test(filenameOf(thumb)));
      visible = [...new Set([featured, ...details].filter(Boolean))];
      if (color === 'nero') {
        const editorial = thumbs.filter(thumb => filenameOf(thumb).startsWith('nawr-just-relax-black-'));
        visible = [...new Set([...editorial, ...visible])];
        mainEditorial = editorial.find(thumb => filenameOf(thumb).includes('01-cortile')) || editorial[0];
      }
    }
    thumbs.forEach(thumb => { thumb.hidden = !visible.includes(thumb); });
    const strip = gallery.querySelector('.gallery-thumbnails');
    if (strip) strip.hidden = visible.length < 2;
    const first = mainEditorial || (featured && visible.includes(featured) ? featured : visible[0]);
    if (first) first.click();
  }
  function initGalleries(root) {
    root.querySelectorAll('[data-product-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const main = gallery.querySelector('[data-gallery-main]');
      if (!main) return;
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(thumb => {
        thumb.addEventListener('click', () => {
          main.removeAttribute('srcset');
          main.removeAttribute('sizes');
          main.src = thumb.dataset.full;
          main.alt = thumb.dataset.alt;
          gallery.querySelectorAll('[data-gallery-thumb]').forEach(item => {
            const active = item === thumb;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
        });
      });
    });
  }
  const init = root => { initCatalog(root); initGalleries(root); initVariants(root); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();


(() => {
  const init = () => {
    const page = document.querySelector('.product-page');
    if (!page || page.dataset.conversionReady) return;
    page.dataset.conversionReady = 'true';
    const guide = page.querySelector('.product-description .table-responsive');
    const destination = page.querySelector('[data-size-guide-content]');
    if (guide && destination) {
      const heading = guide.previousElementSibling;
      if (heading?.querySelector('.size-guide-title')) heading.remove();
      destination.prepend(guide);
    }
    const bar = page.querySelector('[data-mobile-purchase]');
    const form = page.querySelector('.product-form');
    if (bar && form) {
      bar.hidden = false;
      const observer = new IntersectionObserver(entries => {
        bar.hidden = entries[0].isIntersecting;
      }, { threshold: 0.1 });
      observer.observe(form);
      const select = form.querySelector('[data-variant-select]');
      select?.addEventListener('change', () => {
        page.querySelector('[data-mobile-price]').textContent = select.selectedOptions[0].dataset.price;
        const url = new URL(location.href);
        url.searchParams.set('variant', select.value);
        history.replaceState({}, '', url);
      });
      bar.querySelector('a').addEventListener('click', () => {
        const target = select || form.querySelector('button');
        if (target) target.focus({ preventScroll: true });
      });
    }
    const reviewLink = page.querySelector('[data-review-link]');
    const reviews = document.querySelector('.nawr-reviews');
    if (reviewLink && reviews) {
      reviews.id = 'nawr-customer-reviews';
      const update = () => {
        const summary = reviews.querySelector('.jdgm-rev-widg__summary');
        const text = summary?.textContent.replace(/\s+/g, ' ').trim();
        if (!text || !summary.querySelector('.jdgm-star')) return;
        reviewLink.textContent = '★ ' + text;
        reviewLink.hidden = false;
      };
      const observer = new MutationObserver(update);
      observer.observe(reviews, {childList:true, subtree:true, characterData:true});
      update();
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

